/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharereviewtoptitle3Inputs */

const en_sharereviewtoptitle3 = /** @type {(inputs: Sharereviewtoptitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most cashback this month`)
};

const de_sharereviewtoptitle3 = /** @type {(inputs: Sharereviewtoptitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meistes Cashback diesen Monat`)
};

/**
* | output |
* | --- |
* | "Most cashback this month" |
*
* @param {Sharereviewtoptitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharereviewtoptitle3 = /** @type {((inputs?: Sharereviewtoptitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharereviewtoptitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharereviewtoptitle3(inputs)
	return de_sharereviewtoptitle3(inputs)
});
export { sharereviewtoptitle3 as "shareReviewTopTitle" }